// frontend/src/hooks/useBadges.ts

import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabaseClient';
import { useAuthStore } from '../store/authStore';
import { AchievementWithStatus } from '../types/badge.types';

export function useBadges() {
  const userId = useAuthStore((s) => s.session?.user.id);
  const [badges, setBadges] = useState<AchievementWithStatus[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!userId) return;
    let cancelled = false;

    async function load() {
      setIsLoading(true);
      setError(null);
      try {
        const [allRes, earnedRes] = await Promise.all([
          supabase.from('achievements').select('*').order('xp_reward', { ascending: true }),
          supabase
            .from('student_achievements')
            .select('achievement_id, earned_at')
            .eq('student_id', userId),
        ]);

        if (allRes.error) throw allRes.error;
        if (earnedRes.error) throw earnedRes.error;

        const earnedMap = new Map((earnedRes.data ?? []).map((e) => [e.achievement_id, e.earned_at]));

        const merged: AchievementWithStatus[] = (allRes.data ?? []).map((a) => ({
          ...a,
          earned: earnedMap.has(a.id),
          earnedAt: earnedMap.get(a.id) ?? null,
        }));

        // Kazanılanlar önce, sonra kilitli olanlar
        merged.sort((a, b) => Number(b.earned) - Number(a.earned));

        if (!cancelled) setBadges(merged);
      } catch (err) {
        if (!cancelled) setError(err instanceof Error ? err.message : 'Rozetler yüklenemedi.');
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, [userId]);

  return { badges, isLoading, error };
}
